<template>
  <div>
    <v-data-table
      :loading="loading"
      loading-text="Loading..."
      :items="data"
      hide-default-header
      hide-default-footer
      class="elevation-1"
      :items-per-page="9999"
    >
      <template v-slot:header>
        <thead class="v-data-table-header">
          <tr v-if="headers1.length !== 0" class="head1">
            <th
              v-for="head in headers1"
              :class="`font-weight-normal ${head.align}`"
              :style="head.style"
              :rowspan="head.rowspan || ''"
              :colspan="head.colspan || ''"
              :key="head.value"
            >
              {{ head.text }}
            </th>
          </tr>
          <tr v-if="headers2.length !== 0">
            <th
              v-for="head in headers2"
              :class="head.align"
              :style="head.style"
              :rowspan="head.rowspan || ''"
              :colspan="head.colspan || ''"
              :key="head.value"
            >
              <div v-if="head.type === 'percent' && head.text !== ''">
                {{ head.text | numberToPercent }}
              </div>
              <div v-else-if="head.type === 'totalPercent' && head.text !== ''">
                <v-progress-linear
                  v-if="head.text !== 0"
                  :value="head.text"
                  :color="$getGrayColor[0]"
                  height="15"
                >
                </v-progress-linear>
              </div>
              <div v-else-if="head.type === 'notDisplay'"></div>
              <div v-else>{{ head.text }}</div>
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="props">
        <tr>
          <td>
            {{ props.item.name }}
          </td>
          <td>
            <div class="text-right">{{ props.item.value }}</div>
          </td>
          <td>
            <div class="text-right">
              {{ props.item.percent | numberToPercent }}
            </div>
          </td>
          <td>
            <v-progress-linear
              v-if="props.item.percent !== 0"
              :value="props.item.percent"
              :color="$getGrayColor[0]"
              height="15"
            >
            </v-progress-linear>
          </td>
        </tr>
      </template>

      <template v-if="headers1.length !== 0 && data.length === 0" v-slot:body>
        <tbody>
          <tr class="v-data-table__empty-wrapper">
            <td class="text-center" :colspan="5">No data available</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    headers1: Array,
    headers2: Array,
    data: Array,
    total: Number,
    totalPercent: Number
  },
  watch: {
    data: {
      handler(newOptionValue) {
        this.headers2[1].text = this.total ? this.total : ''
        this.headers2[2].text = this.total ? this.totalPercent : ''
        this.headers2[3].text = this.total ? this.totalPercent : ''
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.font-weight-normal {
  font-weight: normal;
}

::v-deep .v-data-table {
  border: unset !important;
}

::v-deep .v-data-table__wrapper {
  // min-height: 150px !important;
  height: unset !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 37px !important;
  padding: 0 7px !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > .head1 > th {
  border-top: unset !important;
  border-right: unset !important;
  border-left: unset !important;
  background-color: white !important;
}
</style>
